<template>
  <div id="lotto">
    <div class="rightContent">
      <div class="tableheader">
        <div style="text-align:right;float:right">
          <el-select @change="getList" v-model="cate" placeholder="彩票分类" size="mini" style="margin-right:10px;">
            <el-option key="kk0" label="全部" value=""></el-option>
            <el-option v-for="(item,i) in catelist" :key="'k'+i" :label="item.cate" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="listBlock">
        <el-table :data="lists" style="width: 100%">
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="lotto_name" label="彩票名称"></el-table-column>
          <el-table-column prop="cate_name" label="彩票类型"></el-table-column>
          <el-table-column label="彩票状态">
            <template slot-scope="scope">
              <span v-if="scope.row.lotto_status==1">封盘中</span>
              <span v-else>开盘中</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-switch
                @change="submitSave(scope.row.id, scope.row.lotto_status)"
                v-model="scope.row.lotto_status"
                active-color="#ff4949"
                inactive-color="#13ce66"
                active-value="1"
                inactive-value="0"
                active-text="封盘"
                inactive-text="开盘">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "lotto",
  data() {
    return {
      doing: false,
      doing2: false,
      lists: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      catelist: '',
      cate: ''
    };
  },
  computed: {},
  created() {
    this.getCate();
    this.resizedwindow();
    this.getList();
  },
  methods: {
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPng = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.error('图片格式必须是png或jpg');
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2M');
      }
      return (isJPG || isPng) && isLt2M;
    },
    uploadFileOk(res, file) {
      this.saveForm.filename = URL.createObjectURL(file.raw);
      if (res.code == 10000) {
        this.saveForm.filename = res.img_path;
      }
    },
    getCate() {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {}
      this.axios
        .post("/kaiSrv/mgr/cateList", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code == 0) {
            _this.catelist = response.data.list;
          }
        });
    },
    getList() {
      if (this.doing2 === true) {
        return false;
      }
      let dataLoadIng = this.openFullScreen()
      this.doing2 = true;
      let _this = this;
      let data = {
        cate_id: this.cate
      }
      this.axios
        .post("/kaiSrv/mgr/lottoList", this.formData(data))
        .then(function(response) {
          _this.doing2 = false;
          if (response.data.code == 0) {
            _this.lists = response.data.list;
          }
          setTimeout(() => {
            dataLoadIng.close()
          }, 500);
        });
    },
    submitSave(id, status) {
      console.log(status)
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {
        id: id,
        lotto_status: status
      };
      this.axios
        .post("/kaiSrv/mgr/lottoStatus", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          _this.dialogFormVisible = false;
          _this.getList();
        });
    }
  }
};
</script>
<style  lang="scss">
#lotto {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-input__inner {
    width: 2.5rem;
  }
  .codeshearch,
  .codeshearch .el-input__inner {
    width: 1.5rem;
  }
  .el-pagination .el-input__inner {
    width: 0.9rem;
  }
  .codeshearch {
    margin-left: 0.05rem;
    margin-right: 0.02rem;
  }
  .avatar-uploader,
  .el-upload,
  .el-upload--text {
    width: 1.22rem;
    height: 1.2rem;
    display: inline-block;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
}
</style>
<style scoped lang="scss">
#lotto {
  box-sizing: border-box;
  .rightContent {
    width: calc(100% - 0.32rem);
    height: calc(100% - 0.1667rem);
    display: inline-block;
    background-color: #fff;
    margin-left: 0.1667rem;
    margin-top: 0.1667rem;
    border-radius: 0.05rem;
    .tableheader {
      margin: 0.16rem;
    }
    p.title {
      height: 0.4167rem;
      line-height: 0.4167rem;
      font-size: 0.15rem;
      color: #000;
    }
    .btn2,
    .btn3 {
      padding: 0.0667rem 0.0833rem;
      background-color: #409EFF;
      border: 1px solid #409EFF;
    }
    .listBlock {
      margin: 0.08rem;
    }
    .warncolor {
      color: red;
    }
    .btndel {
      margin-left: 0.1rem;
      height: 0.28rem;
      position: relative;
      top: 0.05rem;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 1.22rem;
    height: 0.5rem;
    margin-left: 1rem;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    color: #8c939d;
    width: 1.22rem;
    height: 1.22rem;
    text-align: center;
    line-height: 1.22rem;
    margin-top: 0.08rem;
  }
  .imgblockForLogo {
    width: 1.22rem;
    height: 1.22rem;
    display: inline-block;
    border: 1px solid #ccc;
    margin-top: 0.08rem;
  }
  .avatar {
    width: 1.22rem;
    height: 1.22rem;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/lotto.vue